(function () {
  var roots = document.querySelectorAll('[data-home-carousel]');
  if (!roots.length) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cardDelay = 3000;
  var cardDuration = 1400;
  var slideDuration = 1000;

  function initProductTrack(track) {
    var items = track.children;
    var visible = 3;
    if (items.length <= visible) return;

    var frame = track.parentElement;
    var slide = track.closest('[data-slide]');
    var moving = false;
    var hovering = false;
    var focused = false;

    function lockHidden() {
      Array.prototype.forEach.call(items, function (item, itemIndex) {
        item.inert = itemIndex >= visible;
      });
    }

    function finish() {
      if (!moving) return;
      track.classList.remove('is-moving');
      track.appendChild(items[0]);
      track.style.transform = '';
      lockHidden();
      moving = false;
    }

    function advance() {
      if (moving || hovering || focused || document.hidden || (slide && !slide.classList.contains('is-active'))) return;
      var step = items[1].offsetLeft - items[0].offsetLeft;
      if (!step) return;
      moving = true;
      items[visible].inert = false;
      track.classList.add('is-moving');
      track.style.transform = 'translateX(' + -step + 'px)';
      window.setTimeout(finish, cardDuration + 50);
    }

    lockHidden();
    if (reduceMotion) return;

    frame.addEventListener('mouseenter', function () { hovering = true; });
    frame.addEventListener('mouseleave', function () { hovering = false; });
    frame.addEventListener('focusin', function () { focused = true; });
    frame.addEventListener('focusout', function (event) {
      if (!frame.contains(event.relatedTarget)) focused = false;
    });

    window.setInterval(advance, cardDelay);
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-product-track]'), initProductTrack);

  Array.prototype.forEach.call(roots, function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    var pause = root.querySelector('[data-pause]');
    if (slides.length < 2) return;

    var index = 0;
    var timer = null;
    var paused = reduceMotion;
    var delay = 6500;
    var leaveTimer = null;

    function reset(slide) {
      slide.classList.add('is-instant');
      slide.classList.remove('is-active', 'is-leaving');
      void slide.offsetHeight;
      slide.classList.remove('is-instant');
    }

    function setActive(slide, active) {
      slide.inert = !active;
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    }

    function show(nextIndex) {
      nextIndex = (nextIndex + slides.length) % slides.length;
      if (nextIndex === index) return;
      var current = slides[index];
      var incoming = slides[nextIndex];

      slides.forEach(function (slide) {
        if (slide !== current) reset(slide);
      });
      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      setActive(current, false);
      incoming.classList.add('is-active');
      setActive(incoming, true);

      window.clearTimeout(leaveTimer);
      leaveTimer = window.setTimeout(function () {
        if (!current.classList.contains('is-active')) reset(current);
      }, slideDuration);

      index = nextIndex;
      dots.forEach(function (dot, dotIndex) {
        if (dotIndex === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function play() {
      stop();
      if (paused) return;
      timer = window.setInterval(function () {
        show(index + 1);
      }, delay);
    }

    function setPaused(value) {
      paused = value;
      if (pause) {
        pause.setAttribute('aria-pressed', paused ? 'true' : 'false');
        pause.setAttribute('aria-label', paused ? pause.getAttribute('data-play-text') : pause.getAttribute('data-pause-text'));
        pause.classList.toggle('is-paused', paused);
      }
      if (paused) stop();
      else play();
    }

    if (prev) {
      prev.addEventListener('click', function () {
        show(index - 1);
        play();
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        show(index + 1);
        play();
      });
    }
    dots.forEach(function (dot, dotIndex) {
      dot.addEventListener('click', function () {
        show(dotIndex);
        play();
      });
    });
    if (pause) {
      pause.addEventListener('click', function () {
        setPaused(!paused);
      });
    }

    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        show(index + 1);
        play();
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        show(index - 1);
        play();
      }
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', function () {
      if (!paused) play();
    });
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget) && !paused) play();
    });

    if (paused) setPaused(true);
    else play();
  });
})();
